import { cookieStorage, createStorage, createConfig, http } from "wagmi";
import { base, baseSepolia } from "wagmi/chains";
import { State, WagmiProvider } from "wagmi";
import { createWeb3Modal, defaultWagmiConfig } from "@web3modal/wagmi/react";
import { wagmiProjectId } from "./wagmi.config.";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const metadata = {
  name: "NodeManager",
  description: "mlayer node manager",
  url: process.env.REACT_APP_APP_URL ?? `${window.location.origin}`, // origin must match your domain & subdomain
  icons: [`${window.location.origin}/logo.png`],
};

const chains = [
  // base,
  baseSepolia,
] as const;
export const config = createConfig({
  chains,
  ssr: true,
  storage: createStorage({
    storage: cookieStorage,
  }),
  transports: {
    // [base.id]: http(),
    [baseSepolia.id]: http(),
  },
});

export type ClientWagmiProviderProps = {
  children: React.ReactNode;
  initialState?: State;
};

export const web3ModalConfig = defaultWagmiConfig({
  metadata,
  chains: config.chains,
  projectId: wagmiProjectId,
  ssr: true,
  storage: config.storage,
});

createWeb3Modal({
  metadata,
  wagmiConfig: web3ModalConfig,
  projectId: wagmiProjectId,
});

// export default function AppWagmiProvider() {
//   return (
//     <WagmiProvider config={web3ModalConfig} initialState={initialState}>
//       <ClientQueryClientProvider>{children}</ClientQueryClientProvider>
//     </WagmiProvider>
//   );
// }

export default function ClientWagmiProvider({
  children,
  initialState,
}: ClientWagmiProviderProps) {
  const queryClient = new QueryClient();
  return (
    <WagmiProvider config={web3ModalConfig} initialState={initialState}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
